/** Accept explicit zero; empty or invalid values use the documented default. */
export function parseSampleRate(value: string | undefined, fallback: number): number {
  if (!value?.trim()) return fallback;
  const rate = Number(value);
  return Number.isFinite(rate) && rate >= 0 && rate <= 1 ? rate : fallback;
}

export function getSentryConfig(env: Partial<ImportMetaEnv>) {
  const dsn = env.VITE_APP_SENTRY_DSN?.trim();
  const enabled = Boolean(dsn) && env.VITE_APP_SENTRY_DISABLED !== 'true';
  const sessionSampleRate = parseSampleRate(env.VITE_APP_SENTRY_REPLAYS_SESSION_SAMPLE_RATE, 0.1);
  const errorSampleRate = parseSampleRate(env.VITE_APP_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE, 1);

  return {
    enabled,
    dsn,
    environment: env.VITE_APP_SENTRY_ENVIRONMENT || 'development',
    release: env.VITE_APP_SENTRY_RELEASE,
    debug: env.DEV === true,
    tracesSampleRate: parseSampleRate(env.VITE_APP_SENTRY_TRACES_SAMPLE_RATE, 0.1),
    replayEnabled:
      enabled &&
      env.VITE_APP_SENTRY_REPLAY_ENABLED === 'true' &&
      (sessionSampleRate > 0 || errorSampleRate > 0),
    sessionSampleRate,
    errorSampleRate,
  };
}

export const sentryConfig = getSentryConfig(import.meta.env);
